<template>
  <div class="min-h-screen bg-gray-100 flex items-center justify-center">
    <div class="max-w-md w-full bg-white rounded-lg shadow-md p-8">
      <div class="mb-8 text-center">
        <h2 class="text-3xl font-bold text-gray-900">Accesso Amministratore</h2>
        <p class="mt-2 text-sm text-gray-600">Inserisci le tue credenziali per accedere</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="space-y-6">
        <div>
          <label for="username" class="block text-sm font-medium text-gray-700">
            Username
          </label>
          <input
            id="username"
            v-model="username"
            type="text"
            required
            :disabled="isLoading"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100"
            placeholder="Inserisci username"
          />
        </div>
        
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Password
          </label>
          <input
            id="password"
            v-model="password"
            type="password"
            required
            :disabled="isLoading"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100"
            placeholder="Inserisci password"
          />
        </div>
        
        <div v-if="errorMessage" class="text-red-600 text-sm text-center">
          {{ errorMessage }}
        </div>
        
        <div>
          <button
            type="submit"
            :disabled="isLoading"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="isLoading" class="mr-2">
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
            {{ isLoading ? 'Accesso in corso...' : 'Accedi' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import axios from 'axios'
import configuration from '@/config/config';

const API_BASE = configuration.API_BASE_URL  || 'http://localhost:3454'

@Options({})
export default class LoginView extends Vue {
  username = ''
  password = ''
  errorMessage = ''
  isLoading = false

  

  async handleLogin() {
    this.errorMessage = ''
    this.isLoading = true

    try {
      // Verifica credenziali
      const validUsername = configuration.LOGIN_USERNAME
      const validPassword = configuration.LOGIN_PASSWORD

      if (this.username !== validUsername || this.password !== validPassword) {
        this.errorMessage = 'Credenziali non valide'
        this.isLoading = false
        return
      }

      // Chiamata API per tracciare l'accesso
      await this.logAccess()

      // Salva stato autenticazione per questa sessione
      sessionStorage.setItem('isAuthenticated', 'true')
      
      // Redirect alla home
      this.$router.push('/')

    } catch (error) {
      console.error('Errore durante il login:', error)
      this.errorMessage = 'Errore durante il login. Riprova.'
    } finally {
      this.isLoading = false
    }
  }

  private async logAccess() {
    try {
      const payload = {
        user: this.username,
        ipAddress: await this.getUserIP(),
        time: new Date().toISOString(),
        action: 'accesso'
      }

      await axios.post(`${API_BASE}/api/pianificazioni/register` || '', payload)
    } catch (error) {
      console.error('Errore nel log dell\'accesso:', error)
      // Non blocchiamo il login se il logging fallisce
    }
  }

  private async getUserIP(): Promise<string> {
    try {
      // Prova a ottenere l'IP pubblico
      const response = await axios.get('https://api.ipify.org?format=json')
      return response.data.ip
    } catch (error) {
      console.warn('Impossibile ottenere IP pubblico:', error)
      return 'unknown'
    }
  }
}
</script>